// extracted by mini-css-extract-plugin
module.exports = {"input":"toggle_input__Yw_jS","label":"toggle_label__aVs4E"};